import { IError } from '../../../../models/response/error';

interface IErrorProps {
  errors: IError;
}

const Errors = ({ errors }: IErrorProps) => (
  <ul>
    {errors &&
      Object.keys(errors).map((keyName) => (
        <li key={keyName}>
          <span className="text-right text-red-500 mt-1 text-xs italic">{errors[keyName].toString()}</span>
        </li>
      ))}
  </ul>
);

export default Errors;
